//
//
//
//
//
//
//

export default {
    name: 'UiCTALink',
    props: {
        href: {
            type: String,
            default: null,
        },
    },
    computed: {
        component() {
            if (this.href) {
                return 'a';
            }

            return 'button';
        },
    },
};
